<template>
    <div class="ml-auto is-flex is-align-items-center is-flex-wrap-wrap mat-schedule-delay-status">
        <span class="is-size-7 has-text-grey-light mr-3">
            {{ translate("page.schedule_status.expected_end") }}
            <span class="has-text-white">{{ expectedEnd }}</span>
            <span class="mx-1">→</span>
            {{ translate("page.schedule_status.actual_end") }}
            <span class="has-text-white">{{ estimatedEnd }}</span>
        </span>
        <span class="tag mt-2-mobile" :class="delayTagClass">{{ delayLabel }}</span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../Common/translations";
    import { convertToTimezone } from "../Common/dateTimeUtils";
    import timeFormatter from "../Common/timeFormatter";
    import type { MatScheduleDelay } from "../Api/mats";

    // Differences below a minute are shown as "on time", the schedule is not precise to the second.
    const ON_TIME_THRESHOLD_SECONDS = 60;

    const props = defineProps<{
        scheduleDelay: MatScheduleDelay;
        eventTimezone: string;
    }>();

    const expectedEnd = computed(() => convertToTimezone(props.scheduleDelay.expectedEndTime, props.eventTimezone, "HH:mm"));
    const estimatedEnd = computed(() => convertToTimezone(props.scheduleDelay.actualEndTime, props.eventTimezone, "HH:mm"));

    const isOnTime = computed(() => Math.abs(props.scheduleDelay.delay) < ON_TIME_THRESHOLD_SECONDS);
    const isBehind = computed(() => props.scheduleDelay.delay > 0);

    const delayTagClass = computed(() => (!isOnTime.value && isBehind.value ? "is-warning" : "is-success"));

    const delayLabel = computed(() => {
        if (isOnTime.value) {
            return translate("page.start_fights.on_time");
        }

        const duration = timeFormatter.formatSecondsToMinutesAndSeconds(Math.abs(props.scheduleDelay.delay), "compact");

        return (isBehind.value ? "+" : "-") + duration;
    });
</script>
